import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    private apiUrl = environment.apiUrl + 'DrakeData';

    constructor(private http: HttpClient) { }

    // File Upload API
    uploadFile(payload: any, overwrite: boolean = false): Observable<any> {
      const params = new HttpParams().set('overwrite', String(overwrite));

      return this.http.post<any>(`${this.apiUrl}/UploadFile`, payload, { params });
    }

    uploadExternalFile(payload: any): Observable<any> {
      return this.http.post(`${this.apiUrl}/UploadExternalFile`, payload);
  }
  
    
    deleteFile(fileId: string): Observable<any> {
      return this.http.delete<any>(`${this.apiUrl}/DeleteFile/${fileId}`);
  }

  updateShareLevel(fileId: string, newShareLevel: string, isExternal: boolean, isEdit: boolean = false): Observable<any> {
    const payload = {
        FileId: fileId,
        NewShareLevel: newShareLevel,
        IsExternal: isExternal,
        IsEdit: isEdit
    };

    return this.http.put(`${this.apiUrl}/UpdateShareLevel`, payload);
  }
  
  updateFolderShareLevel(folderId: string, newShareLevel: string, isEdit: boolean = false): Observable<any> {
    const url = `${this.apiUrl}/UpdateFolderShareLevel`;
    return this.http.put(url, { folderId, newShareLevel, isEdit });
  }
  



    // Folder APIs
    getFolders(parentId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}drakeData/GetFolders/${parentId}`);
    }

    getFolderByName(name: string): Observable<any[]> {
      const encodedName = encodeURIComponent(name); 
      return this.http.get<any[]>(`${environment.apiUrl}drakeData/GetFolderByName/${encodedName}`);
  }

  getFolderByNameAndParent(name: string, parentId: string): Observable<any[]> {
    const encodedName = encodeURIComponent(name); 
    return this.http.get<any[]>(`${environment.apiUrl}drakeData/GetFolderByNameAndParent/${encodedName}/${parentId}`);
}
  
    
    // Folder APIs
    getFiles(parentId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}drakeData/GetFilesByFolder/${parentId}`);
    }
    getFileUse(fileId: string): Observable<any[]> {
      return this.http.get<any[]>(`${environment.apiUrl}drakeData/GetFileUse/${fileId}`);
  }
    getFoldersHierarchy(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}drakeData/getFoldersHierarchy`);
    }
    readFileAsBase64String(fileId:string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}drakeData/ReadFileAsBase64String/${fileId}`,);
    }

    createFolder(folder: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}drakeData/CreateFolder`, folder, { responseType: 'text' }).pipe(
          map((response) => {
            // Assuming response is the ID string of the new folder
            return {
              ...folder,
              id: response, // Attach the response (ID string) to the folder object
            };
          })
        );
      }

    updateFolder(folder: any): Observable<any> {
        return this.http.put<any>(`${environment.apiUrl}drakeData/UpdateFolder`, folder);
    }

    deleteFolder(folderId: string): Observable<any> {
        return this.http.delete<any>(`${environment.apiUrl}drakeData/DeleteFolder/${folderId}`);
    }
      
    updateFileName(fileId: string, newFileName: string, newFolderId: string): Observable<any> {
      const payload = { fileId, newFileName, newFolderId };
      return this.http.put(`${environment.apiUrl}DrakeData/UpdateFileFolder`, payload);
    }
    
    updateFileFolder(fileId: string, newFileName: string, newFolderId: string): Observable<any> {
      const payload = { fileId, newFileName, newFolderId };
      return this.http.put(`${this.apiUrl}/UpdateFileFolder`, payload);
    }
}
